import { render, staticRenderFns } from "./ModalFormWalletComponent.vue?vue&type=template&id=692ccd0a"
import script from "./ModalFormWalletComponent.vue?vue&type=script&lang=js"
export * from "./ModalFormWalletComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports